import { z } from 'zod';
import { Shortlist } from '../../../__types__';

// Define the shortlist schema based on the backend API response
export const shortlist$ = z.object({
  id: z.number(),
  guid: z.string(),
  title: z.string().nullable(),
  description: z.string().nullable(),
  public_title: z.string().nullable(),
  public_id: z.string().optional(),
  public_description: z.string().nullable(),
  status: z
    .enum(['BUILDING', 'BUILD_COMPLETE', 'PUBLISHED', 'FEEDBACK'])
    .nullable(),
  public: z.boolean().nullable(),
  published: z.boolean().nullable(),
  published_at: z.string().nullable(), // ISO date string
  restricted: z.boolean().optional().nullable(),
  expanded: z.boolean().nullable(),
  archived: z.boolean(),
  created_at: z.string(), // ISO date string
  updated_at: z.string(), // ISO date string
  created_mechanism: z.string().nullable(),
  user_id: z.string().nullable(),
  shortlist_type_id: z.number().nullable(),
  layout: z.enum(['PAGE', 'GRID', 'COMPACT']).nullable(),
  default_fields: z.array(z.string()).nullable(),
  default_resources_query: z.unknown().nullable(),
  show_availability: z.unknown().nullable(),
  private_password: z.string().nullable(),
  enable_voting: z.boolean().nullable(),
  enable_commenting: z.boolean().nullable(),
  public_feedback: z.boolean().nullable(),
  enable_notifications: z.boolean().nullable(),
  tasklist_id: z.number().nullable(),
  // Tags relationship
  tags: z
    .array(
      z.object({
        id: z.number(),
        tag: z.string(),
        tag_type: z.string()
      })
    )
    .optional()
    .nullable(),
  // Groups relationship (legacy, might be removed)
  groups: z.array(z.unknown()).default([]),
  // Shortlist type (legacy, might be removed)
  shortlist_type: z.unknown().nullable(),
  // Shortlist blocks are excluded in normalized version
  shortlist_blocks: z.array(z.unknown()).nullable()
});

export const shortlistFromHttp = (
  data: z.infer<typeof shortlist$>
): Shortlist => {
  const {
    published_at,
    created_at,
    updated_at,
    tags,
    shortlist_blocks,
    ...rest
  } = data;

  return {
    ...rest,
    published_at: published_at ? new Date(published_at) : undefined,
    created_at: new Date(created_at),
    updated_at: new Date(updated_at),
    tags: tags || [],
    // Exclude shortlist_blocks for normalized version
    shortlist_blocks: shortlist_blocks || []
  } as unknown as Shortlist;
};
